import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_SLAEDITOR } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIdSLAEditorState extends EntityState<IID_SLAEDITOR, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_SLAEDITOR })
@InterfaceDataStore(InterfaceName.SLA_EDITOR)
export class IIDSLAEditorStore extends EntityStore<IIdSLAEditorState> {
  constructor() {
    super([]);
  }
}
